<template>
    <div>
        <a target="_blank" :href="article.content">
            <UiRippleButton class="brown">
                {{ article.title }}
            </UiRippleButton>
        </a>

    </div>
</template>

<script setup lang="ts">
import { UiRippleButton } from '#components';

const props = defineProps({
    article: {
        type: Object,
        required: true
    }
});
</script> 